import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'ui-icon-close-large',
    templateUrl: './icon-close-large.component.svg',
    styleUrls: ['../icon-base.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class IconCloseLargeComponent { }
